var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "8.09 7.11 9.3 9.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.732 7.11a1 1 0 1 0 0 2.001h3.243l-5.597 5.597a1 1 0 1 0 1.415 1.414l5.596-5.597v3.243a1 1 0 1 0 2 0V8.123a1 1 0 0 0-.293-.72 1 1 0 0 0-.708-.292m0-.001h-5.656z"
  })));
};
export default SvgArrowTopRight;